<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <v-form v-model="isValido">
      <v-card class="" elevation="0" max-width="">
        <v-card-title>
          <span class="text-h6 font-weight-light pl-md-4 pt-md-5">| Relatório de Custo por unidade </span>
        </v-card-title>

        <v-card-text>
          <v-col cols="12">
            <v-row>
              <v-col cols="12">
                <v-checkbox v-model="formRelatorio.naoTrazerNotaADM" label="Não trazer notas de administração" color="success"></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-autocomplete v-model="formRelatorio.numeroUnidade" :items="listUnidade" chips multiple label="Selecionar Unidade" autocomplete="off" prepend-icon="mdi-file-table">
                  <template v-slot:selection="data">
                    <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeItem(data.item)">
                      {{ data.item.text }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-menu ref="menuDe" v-model="menuDe" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dateFormattedDe" label="De" prepend-icon="mdi-calendar" v-mask="['##/##/####']" clearable autocomplete="off" v-bind="attrs" @blur="dateDe = parseDate1(dateFormattedDe)" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="dateDe" no-title @input="menuDe = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu ref="menuAte" v-model="menuAte" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dateFormattedAte" label="Até" prepend-icon="mdi-calendar" v-mask="['##/##/####']" clearable autocomplete="off" v-bind="attrs" @blur="dateAte = parseDate2(dateFormattedAte)" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="dateAte" no-title @input="menuAte = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>
        <v-col cols="12" align="center">
          <v-btn :disabled="btnGerarRelatorio" width="300" color="#3cbc62" class="white--text" @click="gerarRelatorio()">
            Gerar Relatório
          </v-btn>
        </v-col>
      </v-card>
    </v-form>

    <Loading :open="loading" />

    <FormRelatorio :isTheModalOpen="formRelatorio.isOpen" :modalTitleToolbar="formRelatorio.modalTitleToolbar" v-on:fecharModal="formRelatorioClose" v-on:generate-excel="showModal = true">
      <v-row>
        <v-col cols="12">
          <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
        </v-col>

        <v-col cols="12">
          <v-list>
            <v-list-group v-for="(relatorio, i) in infoRelatorio" :key="i" no-action sub-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title v-text="relatorio.unidade.nomeEndereco"></v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item>
                <v-list-item-content>
                  <v-card class="pa-2" elevation="0" v-if="relatorio.relatorioNotasEmitidas">
                    <v-card-title class="headline">
                      <v-icon large left> mdi-abacus </v-icon>
                      <span class="text-h5">Custo Total: R$ {{ relatorio.custoTotal }} </span>
                    </v-card-title>
                    <v-card-text>
                      <Bar height="100%" :chartData="relatorio.graficoCustoMensal" :options="optionsBar"></Bar>
                    </v-card-text>
                  </v-card>

                  <v-card class="pa-2" elevation="0" v-if="relatorio.listaDeItensAgrupados.length > 0">
                    <v-card-text>
                      <DataTable :tableTitle="'Todos os Produtos comprados'" :tableHeader="headerItensAgrupados" :tableRows="relatorio.listaDeItensAgrupados"></DataTable>
                    </v-card-text>
                  </v-card>

                  <v-card class="pa-2" elevation="0" v-if="relatorio.relatorioNotasEmitidas.length > 0">
                    <v-card-title>
                      <span class="text-h6">▸ Nota enviadas</span>
                    </v-card-title>

                    <!-- #region Notas e lista de Itens -->
                    <v-card-text>
                      <v-list>
                        <v-list-group v-for="(nota, j) in relatorio.relatorioNotasEmitidas" :key="j" no-action sub-group>
                          <template v-slot:activator>
                            <v-list-item-content>
                              <v-list-item-title v-text="'Nota: ' + nota.historicoEntrada.descricaoNumeroNota + ' | Data Emissão: ' + _formatStringInBrazilianDateFormat(nota.historicoEntrada.dataEmissao)"></v-list-item-title>
                            </v-list-item-content>
                          </template>

                          <v-list-item>
                            <v-list-item-content>
                              <v-card class="pa-2" elevation="0" v-if="nota.listItem">
                                <v-card-title>
                                  <span class="text-h6">▸ Itens da Nota: {{ nota.historicoEntrada.descricaoNumeroNota }}</span>
                                </v-card-title>
                                <v-card-text>
                                  <DataTable :tableTitle="'Custo total da nota R$ ' + nota.historicoEntrada.valorTotalNota" :tableHeader="headerItens" :tableRows="nota.listItem"></DataTable>
                                </v-card-text>
                              </v-card>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-group>
                      </v-list>
                    </v-card-text>
                    <!-- #endregion -->
                  </v-card>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-col>
      </v-row>
    </FormRelatorio>

    <v-dialog v-model="showModal" max-width="400">
      <template>
        <v-card>
          <v-card-title> <v-row justify="center"> Atenção </v-row> </v-card-title>
          <v-card-text>
            <div class="text-h6 font-weight-regular" align="center" justify="center">
              Gerar relatório apenas de Custo?
            </div>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn @click="gerarExcel(infoRelatorio, 0)" class="red--text" text x-large>NÃO</v-btn>
            <v-btn @click="gerarExcel(infoRelatorio, 1)" class="green--text" text x-large>SIM</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-col>
</template>

<script>
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import axios from "../plugins/axios";
import store from "@/store/index";
import Loading from "../components/Loading.vue";
import FormRelatorio from "../components/FormRelatorio";
import DataTable from "../components/DataTable2.vue";
import Bar from "@/components/Charts/Bar";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import validation from "@/utils/validation";

export default {
  components: {
    FormRelatorio,
    Loading,
    DataTable,
    Bar,
    Alertas,
    AlertasModal,
  },

  computed: {
    computedDateFormatted1() {
      return this.formatDate1(this.dateDe);
    },
    computedDateFormatted2() {
      return this.formatDate2(this.dateAte);
    },
  },

  watch: {
    isValido() {
      this.btnGerarRelatorio = !this.isValido;
    },
    dateDe() {
      this.dateFormattedDe = this.formatDate1(this.dateDe);
      this.formRelatorio.dataInicio = this.dateDe;
    },
    dateAte() {
      this.dateFormattedAte = this.formatDate2(this.dateAte);
      this.formRelatorio.dataFim = this.dateAte;
    },
  },

  data: () => ({
    ...validation,
    options: {
      legend: {
        display: true,
        position: "right",
      },
    },

    optionsBar: {
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
    },

    // #region Headers
    headersEntrada: [
      {
        text: "Nome do Produto",
        value: "NO_ITEM",
      },
      {
        text: "Lote",
        value: "DE_LOTE",
      },
      {
        text: "Validade",
        value: "DT_VALIDADE",
      },
      {
        text: "Quantidade em estoque",
        value: "QT_ESTOQUE",
      },
    ],

    headersSetor: [
      {
        text: "Número da dispensa",
        value: "NU_DISPENSA_SETOR",
      },
      {
        text: "Nome do setor",
        value: "NO_SETOR",
      },
      {
        text: "Descrição do setor",
        value: "DE_SETOR",
      },
      {
        text: "Data dispensa",
        value: "DT_DISPENSA",
      },
    ],
    headerItens: [
      {
        text: "Número do Produto",
        value: "numeroItem",
      },
      {
        text: "Nome do Produto",
        value: "nomeItem",
      },
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Qt. Total",
        value: "quantidadeTotal",
      },
      {
        text: "Qt. Entrada",
        value: "quantidadeEntrada",
      },
      {
        text: "Valor do Item",
        value: "valorItemIndividual",
      },
    ],
    headerItensAgrupados: [
      {
        text: "Nome do Produto",
        value: "nomeItem",
      },
      {
        text: "Valor do Item",
        value: "valorItemIndividual",
      },
      {
        text: "Qt. Entrada",
        value: "quantidadeEntrada",
      },
      {
        text: "Valor Total",
        value: "valorTotal",
      },
    ],
    headersDispensaPaciente: [
      {
        text: "Número dispensa",
        value: "NU_DISPENSA_PACIENTE",
      },
      {
        text: "Nome do paciente",
        value: "DE_NOME",
      },
      {
        text: "CPF paciente",
        value: "DE_CPF",
      },
      {
        text: "Data da dispensa",
        value: "DT_DISPENSA",
      },
    ],
    //#endregion

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    formRelatorio: {
      isOpen: false,
      numeroUnidade: null,
      dataInicio: null,
      dataFim: null,
      naoTrazerNotaADM: false,
      modalTitleToolbar: "Relatório de Custo",
    },
    listUnidade: [],

    //DatePicker
    dateDe: null,
    dateAte: null,
    dateFormattedDe: null,
    dateFormattedAte: null,
    menuDe: false,
    menuAte: false,
    loading: false,
    posicaoLinha: 0,
    showModal: false,
    isValido: true,
    btnGerarRelatorio: false,

    infoRelatorio: [],
  }),

  created() {
    this.initialize();
  },

  methods: {
    //#region Formatar data
    formatDate1(dateDe) {
      if (!dateDe) return null;

      const [day, month, year] = dateDe.split("-");
      return `${year}/${month}/${day}`;
    },

    parseDate1(dateDe) {
      if (!dateDe) return null;
      const [day, month, year] = dateDe.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    formatDate2(dateAte) {
      if (!dateAte) return null;
      const [day, month, year] = dateAte.split("-");
      return `${year}/${month}/${day}`;
    },

    parseDate2(dateAte) {
      if (!dateAte) return null;
      const [day, month, year] = dateAte.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    _formatStringInBrazilianDateFormat(data) {
      if (!data) return null;
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },
    //#endregion

    removeItem(item) {
      const index = this.formRelatorio.numeroUnidade.indexOf(item.value);
      if (index >= 0) this.formRelatorio.numeroUnidade.splice(index, 1);
    },

    async initialize() {
      try {
        const responseEnderecos = await axios.get("enderecoordemservico", this.config);
        this.listUnidade = responseEnderecos.data.map((row) => {
          return {
            value: row.numeroEnderecoOrdemServico,
            text: row.nomeEndereco,
          };
        });
        this.alerta.tipo = "";
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async gerarRelatorio() {
      this.loading = true;
      try {
        const responseRelatorio = await axios.post("/relatorioMovimentacao", this.formRelatorio, this.config);
        this.infoRelatorio = responseRelatorio.data;
        this.alertaModal.tipo = "";
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      } finally {
        this.formRelatorio.isOpen = true;
        this.loading = false;
      }
    },

    formRelatorioClose() {
      this.formRelatorio.numeroUnidade = null;
      this.formRelatorio.dataInicio = null;
      this.dateDe = null;
      this.dateAte = null;
      this.dateFormattedDe = null;
      this.dateFormattedAte = null;
      this.formRelatorio.dataFim = null;
      this.formRelatorio.isOpen = false;
    },

    //#region EXCEL
    async gerarExcel(conteudo, tipoExcel) {
      this.loading = true;
      try {
        if (tipoExcel == 0) {
          const workbook = new Workbook();
          conteudo.map((unidadeSelecionada) => {
            this.posicaoLinha = 1;
            var worksheet = workbook.addWorksheet(unidadeSelecionada.unidade.nomeEndereco, { views: [{ showGridLines: false }] });

            worksheet.columns = [
              { key: "col1", width: 35 },
              { key: "col2", width: 35 },
              { key: "col3", width: 35 },
              { key: "col4", width: 35 },
              { key: "col5", width: 35 },
              { key: "col6", width: 35 },
              { key: "col7", width: 35 },
            ];

            worksheet.mergeCells("A" + this.posicaoLinha + ":D" + this.posicaoLinha);
            worksheet.getCell("A" + this.posicaoLinha).value = "Todos produtos comprados - Custo Total: R$ " + unidadeSelecionada.custoTotal;

            worksheet.getCell("A" + this.posicaoLinha).font = { name: "Arial", family: 2, size: 14, bold: true };
            worksheet.getCell("A" + this.posicaoLinha).alignment = { vertical: "middle", horizontal: "center" };
            worksheet.getCell("A" + this.posicaoLinha).fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "66cc99" },
            };
            this.posicaoLinha++;

            const linhaTitulosTodosItens = worksheet.addRow({
              col1: "Nome do Produto",
              col2: "Valor do Produto",
              col3: "Qt. Entrada",
              col4: "Valor Total",
            });
            linhaTitulosTodosItens.font = { bold: true };

            unidadeSelecionada.listaDeItensAgrupados.map((itenSelecionado) => {
              worksheet.addRow({
                col1: itenSelecionado.nomeItem,
                col2: itenSelecionado.valorItemIndividual,
                col3: itenSelecionado.quantidadeEntrada,
                col4: itenSelecionado.valorTotal,
              }).alignment = { vertical: "top", horizontal: "left" };
              this.posicaoLinha++;
            });

            worksheet.addRow();
            worksheet.addRow();
            worksheet.addRow();
            this.posicaoLinha++;
            this.posicaoLinha++;
            this.posicaoLinha++;

            unidadeSelecionada.relatorioNotasEmitidas.map((notaSelecionada) => {
              worksheet.mergeCells("A" + this.posicaoLinha + ":G" + this.posicaoLinha);
              worksheet.getCell("A" + this.posicaoLinha).value = "Nota: " + notaSelecionada.historicoEntrada.descricaoNumeroNota + " | Data Emissão: " + this._formatStringInBrazilianDateFormat(notaSelecionada.historicoEntrada.dataEmissao);

              worksheet.getCell("A" + this.posicaoLinha).font = { name: "Arial", family: 2, size: 14, bold: true };
              worksheet.getCell("A" + this.posicaoLinha).alignment = { vertical: "middle", horizontal: "center" };
              worksheet.getCell("A" + this.posicaoLinha).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "66cc99" },
              };
              this.posicaoLinha++;

              const linhaTitulos = worksheet.addRow({
                col1: "Número do Produto",
                col2: "Nome do Produto",
                col3: "Lote",
                col4: "Validade",
                col5: "Qt. Total",
                col6: "Qt. Entrada",
                col7: "Valor do Item",
              });
              linhaTitulos.font = { bold: true };

              notaSelecionada.listItem.map((itemSelecionado) => {
                worksheet.addRow({
                  col1: itemSelecionado.numeroItem,
                  col2: itemSelecionado.nomeItem,
                  col3: itemSelecionado.lote,
                  col4: itemSelecionado.validade,
                  col5: itemSelecionado.quantidadeTotal,
                  col6: itemSelecionado.quantidadeEntrada,
                  col7: itemSelecionado.valorItemIndividual,
                }).alignment = { vertical: "top", horizontal: "left" };
                this.posicaoLinha++;
              });

              worksheet.addRow();
              worksheet.addRow();
              worksheet.addRow();
              this.posicaoLinha++;
              this.posicaoLinha++;
              this.posicaoLinha++;
            });

            //STYLE BORDER
            var borderStyles = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };

            worksheet.eachRow({ includeEmpty: true }, function(row) {
              row.eachCell({ includeEmpty: true }, function(cell) {
                cell.border = borderStyles;
              });
            });
          });

          workbook.xlsx.writeBuffer().then(function(data) {
            var blob = new Blob([data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Relatório de Custo.xlsx");
          });

          this.showModal = false;
          this.loading = false;
        } else if (tipoExcel == 1) {
          let posicaoLinha = 1;
          const workbook = new Workbook();
          var worksheet = workbook.addWorksheet("Relatório de Custo", {
            properties: { tabColor: { argb: "FF00FF00" } },
            views: [{ showGridLines: false }],
          });

          worksheet.columns = [
            { key: "col1", width: 20 },
            { key: "col2", width: 30 },
            { key: "col3", width: 30 },
            { key: "col4", width: 30 },
          ];

          worksheet.mergeCells("A1:D1");
          worksheet.getCell("A1").value = "Unidades";
          worksheet.getCell("A1").font = { name: "Arial", family: 2, size: 14, bold: true };
          worksheet.getCell("A1").alignment = { vertical: "middle", horizontal: "center" };
          worksheet.getCell("A1").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "66cc99" } };

          worksheet.mergeCells("E1:H1");
          worksheet.getCell("E1").value = "Custo total";
          worksheet.getCell("E1").font = { name: "Arial", family: 2, size: 14, bold: true };
          worksheet.getCell("E1").alignment = { vertical: "middle", horizontal: "center" };
          worksheet.getCell("E1").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "66cc99" } };
          posicaoLinha++;

          await Promise.all(
            conteudo.map(async (unidadeSelecionada) => {
              worksheet.mergeCells("A" + posicaoLinha + ":D" + posicaoLinha);
              worksheet.getCell("A" + posicaoLinha).value = unidadeSelecionada.unidade.nomeEndereco;
              worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 13 };
              worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "start" };

              worksheet.mergeCells("E" + posicaoLinha + ":H" + posicaoLinha);
              worksheet.getCell("E" + posicaoLinha).value = "R$ " + unidadeSelecionada.custoTotal;
              worksheet.getCell("E" + posicaoLinha).font = { name: "Arial", family: 2, size: 13 };
              worksheet.getCell("E" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
              posicaoLinha++;
            })
          );

          var borderStyles = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          worksheet.eachRow({ includeEmpty: true }, function(row) {
            row.eachCell({ includeEmpty: true }, function(cell) {
              cell.border = borderStyles;
            });
          });

          workbook.xlsx.writeBuffer().then(function(data) {
            var blob = new Blob([data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Relatório de Custo.xlsx");
          });

          this.showModal = false;
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
        this.showModal = false;
        this.loading = false;
      }
    },
    //#endregion
  },
};
</script>

<style></style>
